import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { NavigationHistoryPath, TransactionWithType } from '../types';

export const useGetHistoryEventTitle = () => {
  const { formatMessage } = useIntl();
  return useCallback((type: NavigationHistoryPath['type'] | TransactionWithType['type']) => {
    switch (type) {
      case 'Fuel':
        return formatMessage({ id: 'historyEvent.fuel' });
      case 'Parking':
        return formatMessage({ id: 'historyEvent.Parking' });
      case 'Service':
        return formatMessage({ id: 'historyEvent.Service' });
      case 'Untracked':
        return formatMessage({ id: 'historyEvent.Untracked' });
      default:
        return '';
    }
  }, [formatMessage]);
};
